import { NUMBER_TO_BOOL_MAP } from '~constants/index';
import { Nullable } from '~src/types';

export enum ViewTo {
  'Сити' = 1,
  'Река',
  'Белый дом',
  'Кремль',
  'Гостиница Украина',
  'Мид',
  'Воробьевы горы',
  'МГУ',
  'Живописный мост',
  'Филевский парк',
  'Пресня',
  'Останкино',
}

export enum Likes {
  disliked = -1,
  nothing,
  liked,
}

export type ObjectType = {
  id_crm: number;
  address: string;
  ceil: number;
  cost_d: number;
  cost_r: number;
  costm_d: number;
  costm_r: number;
  floor: number;
  from_builder: number;
  furnish: string;
  furniture: keyof typeof NUMBER_TO_BOOL_MAP;
  realised: keyof typeof NUMBER_TO_BOOL_MAP;
  img: string;
  name: string;
  total_area: number;
  type: 'office' | 'apartment' | 'torg';
  type_listing: 'rent' | 'sale';
  url: string;
  rooms: Nullable<number>;
  view_to: ViewTo[];
};

export type BrokerListingObject = ObjectType & {
  tax: string;
  desc: string;
  liked: Likes;
};
